import { HTTP } from './http'
import { Settings } from '@/settings'

export class CustomerService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

	async list(params) {
		return await super.get('/ajaxselectcustomer', params)
	}

	async get(id) {
		return await super.get('/ajaxselectcustomer', { getselection: id })
	}
}